import React from 'react';
import './top-projects.scss';
import EventCard from '../../components/event-card/event-card';
import classnames from 'classnames';
import useWindowDimensions from '../../useWindowDimentions';
import Browser from '../../components/Browser';
import useSwipe from '../../use-swipe';

const TopProjects = ({services}) => {
    const containerRef = React.useRef();
    const {windowDimensions: {windowWidth}} = useWindowDimensions();
    const eventsPerView = windowWidth > 768 ? 3 : 1;
    const pagesAmount = Math.ceil(services.length / eventsPerView);
    const [currenPage, setCurrentPage] = React.useState(0);
    const startIndex = React.useMemo(() => {
        if (currenPage < pagesAmount - 1) {
            return currenPage * eventsPerView;
        } else if (currenPage === pagesAmount - 1) {
            return Math.max(0, services.length - eventsPerView);
        }
    }, [currenPage, pagesAmount, services.length, eventsPerView]);
    const showPage = (index) => {
        if (index === currenPage || index < 0 || index >= pagesAmount) return;
            setCurrentPage(index);
        if (index > currenPage) {
            showNext(index);
        } else {
            showPrevoius(index);
        }
    };
    const showNext = (index) => {
        if (containerRef.current) {
            const newIndex = index * eventsPerView + eventsPerView - 1;
            const eventIndex = newIndex < services.length ? newIndex : services.length - 1;
            const children = containerRef.current.children;
            children[eventIndex].scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        }
    };
    const showPrevoius = (index) => {
        if (containerRef.current) {
            const eventIndex = index * eventsPerView;
            const children = containerRef.current.children;
            children[eventIndex].scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            })
        }
    };
    const swipe = useSwipe({ref: containerRef, showNext: () => showPage(currenPage + 1), showPrevious: () => showPage(currenPage - 1), sensitivity: 30});
    return (
        <>
            <div className='top-projects position-relative'>
                <div ref={containerRef} className='events-container display-grid column-gap-2rem padding-bottom-2dot375rem position-relative'>
                    {services.map((service, index) => 
                        <div
                            key={service.id}
                            data-insights-object-id={service.id}
                            data-service-slug={service.slug}
                            className={classnames(`events-item events-item-${index}`, {'events-item-start': startIndex === index})}
                        >
                            <EventCard {...{service, mode: 'top'}} />
                        </div>
                    )}
                    
                </div>
                <Browser>
                    <div className={classnames('position-absolute bottom-0 left-50percent transform-translateX-center column-gap-0dot75rem', {'display-flex': pagesAmount > 1, 'display-none': pagesAmount === 1})}>
                        {Array.apply(null, Array(pagesAmount)).map((e, index) =>
                            <div key={index} onClick={() => showPage(index)} className={classnames('cursor-pointer width-2dot5rem height-0dot375rem mw768-height-0dot5rem border-radius-0dot25rem', {'background-color-primary-600': index === currenPage, 'background-color-primary-100': currenPage !== index})}></div>
                        )}
                    </div>
                </Browser>
            </div>
        </>
    )
};

export default React.memo(TopProjects);